module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-e1b945a0.png";